import { render, staticRenderFns } from "./Abrir.vue?vue&type=template&id=2574e65e&scoped=true&"
import script from "./Abrir.vue?vue&type=script&lang=js&"
export * from "./Abrir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574e65e",
  null
  
)

export default component.exports